import { TaInput } from '@components/shared';
import { useTranslation } from 'react-i18next';

export const Individual = ({ getFieldProps, touched, errors }: any) => {
	const { t } = useTranslation();

	return (
		<form className="flex flex-col xs:mt-0 h-full gap-[20px]">
			<TaInput
				id="first_name"
				label={t('firstName')}
				required
				size="small"
				{...getFieldProps('first_name')}
				touched={touched.first_name}
				error={Boolean(touched.first_name && errors.first_name)}
			/>
			<TaInput
				id="last_name"
				label={t('lastName')}
				size="small"
				required
				{...getFieldProps('last_name')}
				touched={touched.last_name}
				error={Boolean(touched.last_name && errors.last_name)}
			/>
			<TaInput
				id="id_number"
				label={t('idNumber')}
				size="small"
				type="text"
				required
				{...getFieldProps('id_number')}
				touched={touched.id_number}
				error={Boolean(touched.id_number && errors.id_number)}
			/>
			{/* Email field removed - will be taken from JWT token */}
			<TaInput
				id="mobile_number"
				label={t('mobileNumber')}
				size="small"
				onKeyPress={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
				type="number"
				required
				{...getFieldProps('mobile_number')}
				touched={touched.mobile_number}
				error={Boolean(touched.mobile_number && errors.mobile_number)}
			/>
		</form>
	);
};
